import { useContext, useEffect, useRef } from "react";

import { useFlags } from "launchdarkly-react-client-sdk";
import { Dialog } from "primereact/dialog";

import { setScormPassed } from "sj-ui-toolkit/src/utils/rxd";

import { VideoContext } from "../../VideoContext";

import FeedbackPage from "../../../../Feedback/FeedbackPage";
import QuizQuestion from "./QuizQuestion";
import QuizQuestions from "./QuizQuestions";
import QuizReview from "./QuizReview";
import QuizSkeleton from "./QuizSkeleton";

import S from "./_styles.module.scss";

export default function QuizContent() {
  const { quiz, feedbackModalVisible, closeFeedbackModal } = useContext(VideoContext);
  const prevResultRef = useRef(quiz?.assessment.result);
  const isQuizComplete = quiz?.assessment.answersCount === quiz?.assessment.questionsCount;
  const { quizRedesign } = useFlags();

  // Call setScormPassed when quiz result changes to "passed"
  useEffect(() => {
    const currentResult = quiz?.assessment.result;
    const previousResult = prevResultRef.current;

    if (previousResult === "in_progress" && currentResult === "passed") {
      setScormPassed({
        score: quiz?.assessment.assessmentScore ?? 0,
        max: 100,
        min: 0,
      });
    }

    prevResultRef.current = currentResult;
  }, [quiz?.assessment.result, quiz?.assessment.assessmentScore]);

  if (!quiz) {
    return <QuizSkeleton />;
  }

  return (
    <div className={S.quizContainer}>
      {isQuizComplete ? (
        <QuizReview />
      ) : quizRedesign ? (
        <QuizQuestions />
      ) : (
        <QuizQuestion
          answersCount={quiz.assessment.answersCount}
          questionsCount={quiz.assessment.questionsCount}
        />
      )}
      <Dialog
        header="Feedback"
        visible={feedbackModalVisible}
        onHide={closeFeedbackModal}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        ariaCloseIconLabel="Close feedback dialog"
      >
        <FeedbackPage forQuiz={true} />
      </Dialog>
    </div>
  );
}
